import React from 'react';
import './Legal.scss';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <header className="legal-page__header">
          <h1 className="legal-page__title">Privacy Policy</h1>
          <p className="legal-page__last-updated">Last updated: August 2025</p>
        </header>

        <div className="legal-page__content">
          <section className="legal-page__section">
            <h2>Information We Collect</h2>
            <p>We only collect information you provide directly when creating an account or using our services:</p>
            <ul>
              <li>Username and profile information</li>
              <li>Game statistics and achievement progress</li>
              <li>Email address (from Google login only)</li>
            </ul>
          </section>

          <section className="legal-page__section">
            <h2>How We Use Your Information</h2>
            <p>We use this information to:</p>
            <ul>
              <li>Operate and improve our gaming service</li>
              <li>Track your personal progress and achievements</li>
              <li>Display public leaderboards and statistics</li>
            </ul>
            <p><strong>We do not sell, rent, or share your personal data with third parties.</strong></p>
          </section>

          <section className="legal-page__section">
            <h2>Cookies and Local Storage</h2>
            <p>
              We use cookies to keep you logged in and local browser storage to save game progress. 
              We do not use tracking or advertising cookies.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Third-Party Services</h2>
            <p>
              We use Google OAuth for login authentication. Google may collect data as described 
              in their privacy policy. We do not use analytics or advertising services.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Your Rights</h2>
            <p>You can access, update, or delete your personal data through your account settings or by contacting us.</p>
          </section>

          <section className="legal-page__section">
            <h2>Contact</h2>
            <p>If you have questions about this privacy policy, email us at guessnexuscompany@gmail.com</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;